(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/store.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/store.js');

'use strict';

const svsconfig = svs.core.config.data.svsconfig;
const {
  configureStore,
  combineReducers
} = RTK;
const {
  accountSlice,
  numbergamesSlice,
  ticketsSlice,
  gamePackageSlice
} = svs.gamePackage.redux;
const {
  loadGamesFromLocalStorage,
  saveGamesToLocalStorage,
  persistGamesMiddleware
} = svs.gamePackage.redux.middlewares;
const reducer = combineReducers({
  account: accountSlice.reducer,
  numbergames: numbergamesSlice.reducer,
  tickets: ticketsSlice.reducer,
  gamePackage: gamePackageSlice.reducer
});
const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(persistGamesMiddleware),
  preloadedState: (() => {
    const numbergamesInitialState = numbergamesSlice.getInitialState();
    const gamesPackageInitialState = gamePackageSlice.getInitialState();
    const foundPersistedGames = loadGamesFromLocalStorage({
      index: gamesPackageInitialState.activeIndex
    });
    const preloadedState = {
      numbergames: _.clone(numbergamesInitialState)
    };
    if (foundPersistedGames) {
      preloadedState.numbergames.games = foundPersistedGames;
    } else {
      saveGamesToLocalStorage({
        index: gamesPackageInitialState.activeIndex,
        games: numbergamesInitialState.games
      });
    }
    return preloadedState;
  })(),
  devTools: svsconfig.env !== 'production'
});
svs.gamePackage.redux.store = store;

 })(window);